import styled from 'styled-components'

export const UlList = styled.ul`
  margin: 0;
  padding: 0 0 0 15px;
  li {
    a {
      color: #000;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`
